import { css } from "lit";

export const selectStyles = css`
  .select {
    outline: none;
    width: 100%;
    height: var(--wow-input-height, 56px);
    padding: var(--wow-input-padding, var(--sds-size-space-400) var(--sds-size-space-600));
    align-items: center;
    align-self: stretch;
    box-sizing: border-box;
    color: var(--sds-color-text-default-default);
    font:
      var(--sds-typography-weight-regular) var(--sds-typography-body-size-large) / 100%
        var(--sds-typography-family-body),
      sans-serif;

    border-radius: var(--sds-size-radius-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);
    cursor: pointer;

    /* Remove default select styling */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    &.with-placeholder {
      padding-top: var(
        --wow-input-placeholder-padding-top,
        calc(var(--sds-size-space-600) + var(--sds-size-space-100))
      );
    }

    &:hover {
      border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-tertiary);
      background: var(--sds-color-background-default-default-hover);
    }

    &:focus {
      border: var(--sds-size-stroke-border) solid var(--sds-color-border-brand-default);
      background: var(--sds-color-background-default-default);
    }

    &:disabled {
      border: var(--sds-size-stroke-border) solid var(--sds-color-border-disabled-default);
      color: var(--sds-color-text-disabled-default);
      background: var(--sds-color-background-disabled-default);
      cursor: not-allowed;
    }

    /* Custom dropdown arrow */
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
    background-position: right var(--wow-input-padding-inline, var(--sds-size-space-600)) center;
    background-repeat: no-repeat;
    background-size: 16px 16px;
    padding-right: calc(var(--wow-input-padding-inline, var(--sds-size-space-600)) + 24px);
  }

  .select.with-prefix {
    padding-left: calc(var(--wow-input-padding-inline, var(--sds-size-space-600)) + 20px + var(--sds-size-space-200));
  }

  .select-prefix {
    position: absolute;
    left: var(--wow-input-padding-inline, var(--sds-size-space-600));
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    pointer-events: none;
    color: var(--sds-color-text-default-secondary);
    line-height: 0;
  }

  .select-placeholder {
    position: absolute;
    left: var(--wow-input-padding-inline, var(--sds-size-space-600));
    top: 50%;
    transform: translateY(-50%);
    font:
      var(--sds-typography-weight-medium) var(--sds-typography-body-size-large) / 1em var(--sds-typography-family-title),
      sans-serif;
    color: var(--wow-input-label-color, var(--sds-color-text-default-tertiary));
    transition: all 0.2s ease-out;
    pointer-events: none;

    &.active {
      top: var(--sds-size-space-300);
      transform: translateY(0);
      font-size: var(--sds-typography-body-size-small);
    }

    &.error {
      color: var(--sds-color-text-danger-secondary);
    }

    &.disabled {
      color: var(--sds-color-text-disabled-default);
    }
  }
`;
